export default "__VITE_ASSET__129659bb__"